var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"id":_vm.id},on:{"enter":_vm.updateRoute}},[_c('PageSection',{attrs:{"title":"education","subtitle":"Learning never ends"}},[_c('TableList',_vm._l((_vm.items),function(item){return _c('SummaryTable',{key:item.id,attrs:{"caption":"title","data":item,"styles":['brackets']}})}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ba5941d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/assets/js/containers/Education/index.vue
// module id = MBSc
// module chunks = 2